import { Text, Center, LoadingOverlay } from '@mantine/core'
import { CreativeForm } from 'components/creatives'
import { useAppTranslation } from 'hooks/useTranslation'
import { useParams } from 'react-router-dom'
import { useQueryCreativeByID } from 'hooks/creatives'

export const EditCreative = () => {
  const { t } = useAppTranslation()
  const { id } = useParams<{ id: string }>()

  const { creative, isLoading, isError, error } = useQueryCreativeByID(id!)

  if (isError) {
    return (
      <Center h={200}>
        <Text c="red">
          {t('common.error')}: {error?.message}
        </Text>
      </Center>
    )
  }

  if (isLoading) {
    return (
      <div style={{ position: 'relative', minHeight: 200 }}>
        <LoadingOverlay visible overlayProps={{ radius: 'sm', blur: 2 }} />
      </div>
    )
  }

  if (!creative) {
    return (
      <Center h={200}>
        <Text>{t('creatives.creative_not_found')}</Text>
      </Center>
    )
  }

  return (
    <div>
      <Text size="xl" fw="bold" mb="lg">
        {t('common.edit')} {creative.title || t('creatives.untitled')}
      </Text>
      <CreativeForm creative={creative} />
    </div>
  )
}